import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dpr53wgyf: FaireProductEntity = {
  token: "p_9dpr53wgyf",
  type: "product",
  name: "Cameron Bracelet",
  brandToken: "b_cn7om55jvr",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/841c7c014d39a05189f741b3c667dc752a3b9dbf87f8f4ed26293b91be645bc9.jpeg",
  galleryImageUrls: [],
  priceDollars: 49.19,
  description:
    '\nFor all you silver jewelry lovers out there, the Cameron bracelet is a must have for your collection! The silver bracelet has a chain link design that is simplistic yet fashionable. Wear it out or wear it in, you can never go wrong with this elegant jewelry!\n\nProduct Details:\n\n * Silver tone titanium \n * Chain link design\n\n * Approx. 2.5" + 2" ext.\n\n * Clasp: snap ',
  tags: [],
  msrpDollars: 98.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:03.703Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
